import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import QueryString from 'query-string';
import { fetchTiles, fetchGlobals, fetchNav, setActiveSubCategories, resetTiles } from '../../../Base/Actions';

// Import components
import HeaderDesktopView from './HeaderDesktopView';
import HeaderMobileView from './HeaderMobileView';
import { getBreakpoint } from '../../../Base/Breakpoints';

class HeaderController extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      header: 'mobile',
      flyoutVisible: false,
      searchVisible: false,
      lastScrollTop: 0,
      lastMobileTouch: 0,
      unfixed: true,
      scrolled: false,
      pinned: false,
      unpinned: false,
    };

    this.toggleFlyout = this.toggleFlyout.bind(this);
    this.closeFlyout = this.closeFlyout.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.openFlyout = this.openFlyout.bind(this);
    this.setHeader = this.setHeader.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.goHome = this.goHome.bind(this);
    this.setHashByActiveSubCategories = this.setHashByActiveSubCategories.bind(this);
  }

  componentWillMount() {
    this.props.fetchNav(this.props.lang);
    this.props.fetchGlobals(this.props.lang);
  }

  componentDidMount() {
    this.setHeader();

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.setHeader);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.setHeader);
  }

  setHeader() {
    const breakpoint = getBreakpoint();
    const header = (breakpoint === 'sm') || (breakpoint === 'md') ? 'mobile' : 'desktop';

    if (header !== this.state.header) {
      this.setState({
        header,
      });
    }
  }

  setHashByActiveSubCategories(subcategories) {
    const query = {};

    Object.keys(subcategories).map((sub) => {
      const taxonomy = subcategories[sub].taxonomy;
      const slug = subcategories[sub].id;
      if (!query[taxonomy]) {
        query[taxonomy] = [];
      }
      query[taxonomy].push(sub);
      return {
        taxonomy,
        slug,
      };
    });
    this.props.history.push({ pathname: `/${process.env.LENSPIRE_CHANNEL}/${this.props.lang}/`, hash: QueryString.stringify(query) });
  }

  goHome() {
    this.props.setActiveSubCategories({});
    this.closeFlyout();
    this.closeSearch();
    this.props.history.push(`/${process.env.LENSPIRE_CHANNEL}/${this.props.lang}/`);
  }

  handleScroll() {
    const elementScroll = document.documentElement.scrollTop;
    const bodyScroll = document.body.scrollTop;
    if (this.state.header === 'mobile') {
      if (!this.state.flyoutVisible) {
        if (elementScroll + bodyScroll < 30 && elementScroll + bodyScroll > 0) {
          this.setState({
            unfixed: true,
            scrolled: true,
          });
        } else if (elementScroll + bodyScroll === 0) {
          this.setState({
            unfixed: false,
            pinned: false,
            unpinned: false,
          });
        } else if (elementScroll > this.state.lastScrollTop || bodyScroll > this.state.lastMobileTouch) {
          this.setState({
            unpinned: true,
            pinned: false,
            unfixed: false,
          });
        } else if (elementScroll < this.state.lastScrollTop || bodyScroll < this.state.lastMobileTouch) {
          this.setState({
            unfixed: false,
            pinned: true,
            unpinned: false,
          });
        } else {
          return;
        }
        this.state.lastScrollTop = elementScroll;
        this.state.lastMobileTouch = bodyScroll;
      }
    }
  }

  toggleFlyout(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      flyoutVisible: !this.state.flyoutVisible,
    });
  }

  closeFlyout(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      flyoutVisible: false,
    });
  }

  toggleSearch(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      searchVisible: !this.state.searchVisible,
    });
  }

  closeSearch(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({
      searchVisible: false,
    });
  }

  openFlyout() {
    if (!this.state.flyoutVisible) {
      this.setState({
        flyoutVisible: true,
      });
    }
  }

  render() {
    if (this.state.header === 'mobile') {
      return (
        <HeaderMobileView
          {...this.props}
          toggleFlyout={this.toggleFlyout}
          closeFlyout={this.closeFlyout}
          openFlyout={this.openFlyout}
          flyoutVisible={this.state.flyoutVisible}
          categories={this.props.categories}
          pinned={this.state.pinned}
          unpinned={this.state.unpinned}
          scrolled={this.state.scrolled}
          unfixed={this.state.unfixed}
          enableOverflow={this.state.enableOverflow}
          goHome={this.goHome}
          setHashByActiveSubCategories={this.setHashByActiveSubCategories}
        />
      );
    }
    if (this.state.header === 'desktop') {
      return (
        <HeaderDesktopView
          {...this.props}
          toggleSearch={this.toggleSearch}
          toggleFlyout={this.toggleFlyout}
          openFlyout={this.openFlyout}
          closeFlyout={this.closeFlyout}
          flyoutVisible={this.state.flyoutVisible}
          searchVisible={this.state.searchVisible}
          categories={this.props.categories}
          links={this.props.links}
          some={this.props.some}
          goHome={this.goHome}
          setHashByActiveSubCategories={this.setHashByActiveSubCategories}
        />
      );
    }

    return null;
  }
}

HeaderController.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        image: PropTypes.shape,
        title: PropTypes.string,
      })),
    }),
  ),
  links: PropTypes.shape({
    'some-label': PropTypes.string,
    statics: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      blank: PropTypes.bool,
      url: PropTypes.string,
    })),
  }),
  some: PropTypes.shape({
    yt: PropTypes.string,
    vimeo: PropTypes.string,
    fb: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    google: PropTypes.string,
  }),
  lang: PropTypes.string,
  history: PropTypes.shape().isRequired,
  fetchNav: PropTypes.func.isRequired,
  setActiveSubCategories: PropTypes.func.isRequired,
  fetchTiles: PropTypes.func.isRequired,
  fetchGlobals: PropTypes.func.isRequired,
  resetTiles: PropTypes.func.isRequired,
  activeSubCategories: PropTypes.shape(),
};

HeaderController.defaultProps = {
  categories: [],
  links: {
    'some-label': '',
    statics: [],
  },
  some: {
    yt: '',
    vimeo: '',
    fb: '',
    twitter: '',
    instagram: '',
    google: '',
  },
  lang: '',
  activeSubCategories: {},
};

function mapStateToProps(state) {
  return {
    categories: state.navState['main-navigation'],
    links: state.navState['header-external-links'],
    some: state.globalsState.social,
    lang: state.globalsState.lang,
    subcategories: state.navState.subcategories,
    activeSubCategories: state.navState.activeSubCategories,
    activeCategory: state.navState.activeCategory,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchNav, fetchGlobals, fetchTiles, setActiveSubCategories, resetTiles }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderController));




// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/HeaderController.jsx